import {Button, Stack, Toolbar} from "@mui/material";
import logoSvg from "../../../assets/logo.svg";
import {Link} from "react-router-dom";
import {useContext} from "react";
import {SignInContext} from "../../../context/SignInContext";
import {IconLogin} from "@tabler/icons-react";


export const LandingHeader = () => {
  const {currentUser} = useContext(SignInContext);

  return (
    <Toolbar sx={{justifyContent: "space-between", position: "fixed", top: 0, left: 0, right: 0, bgcolor: "#ffffff66", backdropFilter: "blur(4px)", zIndex: 5}}>
      <Button
        component={Link} to={"/"}
        startIcon={<img src={logoSvg} height={30} alt={"logo"}/>} sx={{ display: {xs: "none", md: "flex"}, fontSize: "1em", fontWeight: 600 }}
      >
        OpenBrain
      </Button>
      <Button
        component={Link} to={"/"}
        sx={{display: {xs: "flex", md: "none"}}}
      >
        <img src={logoSvg} height={25} alt={"logo"}/>
      </Button>

      <Stack direction={"row"} gap={1} alignItems={"center"}>
        {
          currentUser ?
            <Button
              component={Link} to={"/projects"} variant={"link"} color={"secondary"}
            >
              My Projects
            </Button> :
            <Button
              component={Link} to={"/login"} variant={"link"} color={"secondary"}
            >
              Sign in
            </Button>
        }
        <Button
          onClick={() => {
            const div = document.getElementById("contact-us");
            if (div) {
              div?.scrollIntoView({behavior: "smooth", block: "center"})
            }
          }}
          variant={"contained"} color={"secondary"}
          sx={{
            borderRadius: "24px !important",
            fontSize: {xs: "0.9em", sm: "1em", md: "1.1em"},
            px: {xs: 2, md: 3}, py: 1
          }}
        >
          Get In Touch
        </Button>
      </Stack>
    </Toolbar>
  )
}